import AppShell, { ThemeCtx } from "./AppShell";
import { CaptureContent } from "./CaptureScreen";

export default function EditScreen({ doc, user, activeSub, onDone, onCancel }) {
  const fakeSession = { user, subproject: activeSub };
  return (
    <div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden"}}>
      {/* Back bar */}
      <div style={{flexShrink:0,display:"flex",alignItems:"center",gap:"10px",
        padding:"8px 16px",background:"#fff",borderBottom:"1px solid #E5E7EB",zIndex:1}}>
        <button onClick={onCancel}
          style={{padding:"5px 14px",borderRadius:"8px",border:"1px solid #E5E7EB",
            background:"#fff",color:"#6B7280",fontSize:"12px",fontWeight:"600",cursor:"pointer"}}>
          ← Cancel
        </button>
        <span style={{fontSize:"13px",fontWeight:"700",color:"#374151",
          overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",flex:1}}>
          {doc.SUBJECT||doc.TITLE}
        </span>
      </div>
      {/* Full CaptureContent in edit mode */}
      <div style={{flex:1,overflow:"hidden"}}>
        <CaptureContent session={fakeSession} editDoc={doc} onEditDone={onDone}/>
      </div>
    </div>
  );
}